import { register, CloudObject, defineProperty, defineRelation } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class InspectionModule extends CloudObject { /* empty */ }

// Hardcoded tags
register('01880fcd51a9e378dda1', InspectionModule);
InspectionModule.titleProp = defineProperty('01880fcd8f139ac71373');
InspectionModule.versionsRel = defineRelation('01880fd00af70e9132f4');